Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var coreComponentsShared = require('../../shared');
var utils = require('../utils.js');

var usePortalContainer = function () {
    var getContextPortalContainer = react.useContext(coreComponentsShared.PortalContext);
    if (getContextPortalContainer()) {
        return getContextPortalContainer;
    }
    return utils.getDefaultPortalContainer;
};

exports.usePortalContainer = usePortalContainer;
